import apiClient from "./client";

export const analyticsApi = {
  trackPageview: async (event) => {
    const response = await apiClient.post("/analytics/pageview", event);
    return response.data;
  },

  trackSessionEvent: async (event, token) => {
    const response = await apiClient.post("/analytics/session", event, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    });
    return response.data;
  },

  getReport: async (startDate, endDate) => {
    const response = await apiClient.get("/admin/analytics", {
      params: { startDate, endDate },
    });
    return response.data;
  },

  saveTargets: async (targets) => {
    const response = await apiClient.put("/admin/analytics/targets", targets);
    return response.data;
  },
};
